export type SupportedLocaleType = "nb-NO" | "en-US";

export const DEFAULT_LOCALE: SupportedLocaleType = "nb-NO";
